module.exports = __webpack_public_path__ + "static/img/newbie.f9adc6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profile/newbie.png
// module id = ehKb
// module chunks = 37